// Snapshot of the enum contract understood by the legacy logservice.
// Never reorder these values. New logger enums must be mapped by name.
export enum LegacyEnvironmentName {
    DEV = 0,
    MASTER_HU = 1,
    MASTER_AT = 2,
    STAGING_HU = 3,
    STAGING_AT = 4,
    PROD_HU = 5,
    PROD_AT = 6,
    NONE_OF_THEM = 7,
}

export enum LegacyModuleID {
    BACKEND = 0,
    SHOPSERVICES = 1,
    ADMIN = 2,
    ROKSH_DESKTOP = 3,
    ROKSH_MOBILE = 4,
    DM = 5,
    PM = 6,
    TEST = 7,
    NONE_OF_THEM = 8,
}

export enum LegacyEventType {
    OrderStateChanged = 0,
    OrderItemStateChanged = 1,
    SupplierRegionChanged = 2,
    UserRolesChanged = 3,
    AccountsChanged = 4,
    ClientChanged = 5,
    SupplierDataChanged = 6,
    SupplierWorktimeChanged = 7,
    SupplierResourceChanged = 8,
}

export enum LegacyActionType {
    OrderCreated = 0,
    DeliveryTaskStateChanged = 1,
    DeliveryTaskUserChanged = 2,
    CustomerContactDataChanged = 3,
    EstimatedTimeRecalculated = 4,
    DeliveryTimeSlotChanged = 5,
    MarkupStockCorrectionProcessStarted = 6,
    MarkupCollectingInvoiceAndStockCorrectionProcessStarted = 7,
    MarkupCollectingInvoiceJplGenerated = 8,
    DeliveryInvoiceProcessStarted = 9,
    CustomerCommentsChanged = 10,
    ContainerPlacingTaskCreated = 11,
    DeliveryTaskCreated = 12,
    ReturnProcessStarted = 13,
    DeliveryFeeChanged = 14,
    RefundPaymentStarted = 15,
    OrderCanceled = 16,
    CollectingCheckoutProcessStarted = 17,
    CustomerPhoneCallStarted = 18,
    CollectingDone = 19,
    SupplierRegionNew = 20,
    SupplierRegionRemove = 21,
    SupplierRegionLatLongChanged = 22,
    SupplierRegionNewZip = 23,
    SupplierRegionRemoveZip = 24,
    UserRolesChanged = 25,
    AccountRegistration = 26,
    AccountDeactivate = 27,
    AccountUsernameChanged = 28,
    ClientChangeProfile = 29,
    ClientChangePassword = 30,
    SupplierCreated = 31,
    SupplierUpdated = 32,
    SupplierAccountReset = 33,
    SupplierSumUpAccountUpdated = 34,
    SupplierWorktimeCreated = 35,
    SupplierWorktimeUpdated = 36,
    SupplierWorktimeDeleted = 37,
    SupplierResourceCreated = 38,
    SupplierResourceUpdated = 39,
    SupplierResourceDeleted = 40,
    MyTasksCollectingStarted = 41,
    MyTasksContinueCollectingButtonClicked = 42,
    SearchOfflineProductForOrderItemByGTINButtonClicked = 43,
    SearchOfflineProductForOrderItemBySKUButtonClicked = 44,
    GetOfflineProductByGTIN = 45,
    GetOfflineProductsBySKU = 46,
    AddOrderItemToBasketAsNewProduct = 47,
    AddOrderItemToBasket = 48,
    AddOrderItemToBasketWithQuantity = 49,
    MissingOrderItemButtonClicked = 50,
    MissingOrderItemReasonChanged = 51,
    MissingOrderItemReasonImageChanged = 52,
    ReplaceOrderItemButtonClicked = 53,
    CollectedOrderItemCancelButtonClicked = 54,
    ReplacedOrderItemCancelButtonClicked = 55,
    NotFoundOrderItemCancelButtonClicked = 56,
    ReplacedOrderItemNotFoundButtonClicked = 57,
    ReplaceOrderItemReasonChanged = 58,
    ReplaceOrderItemReasonImageChanged = 59,
    ReplacedOrderItemIdentifyingStarted = 60,
    SearchOfflineProductForReplacedOrderItemByGTINButtonClicked = 61,
    SearchOfflineProductForReplacedOrderItemBySKUButtonClicked = 62,
    AddReplacedOrderItemToBasket = 63,
    RequestApprovalFromTheCustomer = 64,
    MarkupCheckoutButtonClicked = 65,
    UpdateSupportComment = 66,
    PMCheckoutReadQRCodeButtonClicked = 67,
    PMCheckoutQRCodeFound = 68,
    PMInspectionReadQRCodeButtonClicked = 69,
    PMInspectionQRCodeFound = 70,
    PMInspectionRequestButtonClicked = 71,
    PMShowOrderItemsButtonClicked = 72,
    PMApproveOrderButtonClicked = 73,
    PMInspectSelectedOrderItem = 74,
    PMInspectSelectedReplacedOrderItem = 75,
    PMApproveOrderItemButtonClicked = 76,
    PMDeclineOrderItemButtonClicked = 77,
    PMApproveReplacedOrderItemButtonClicked = 78,
    PMDeclineReplacedOrderItemButtonClicked = 79,
    PMInspectingApprovedButtonClicked = 80,
    PMInspectingDeclinedButtonClicked = 81,
    PMMonitoringMissingProductsButtonClicked = 82,
    PMApproveOrderItemButtonDuringMissinMonitoringProcessClicked = 83,
}

export enum LegacyActorType {
    ApplicationUser = 0,
    AdminUser = 1,
    ShopUser = 2,
    System = 3,
}

export enum LegacyCustomLogger {
    None = 0,
    Invoicing = 1,
    StockCorrection = 2,
    AutoTaskFinder = 3,
}
